// extracted by mini-css-extract-plugin
module.exports = {"whiteboardMenuItem":"WhiteboardMenuItem_whiteboardMenuItem__fdCVE","mobile":"WhiteboardMenuItem_mobile__3QVFn"};